import React, { useState, useEffect } from 'react';
import CRUDList from '../Common/CRUDList';
import { airportPairs, airports } from '../../services/api';

// Format distance for display (convert meters to km)
const formatDistance = (meters) => {
  if (!meters) return '-';
  const km = meters / 1000;
  return `${km.toLocaleString()} km`;
};

function AirportPairForm({ formData, setFormData }) {
  const [airportsList, setAirportsList] = useState([]);

  useEffect(() => {
    loadAirports();
  }, []);

  const loadAirports = async () => {
    try {
      const response = await airports.getAll();
      setAirportsList(response.data);
    } catch (err) {
      console.error('Failed to load airports', err);
    }
  };

  return (
    <>
      <div className="form-group">
        <label>Airport 1 *</label>
        <select
          value={formData.apair_airport1_id || ''}
          onChange={(e) => setFormData({ ...formData, apair_airport1_id: parseInt(e.target.value) })}
          required
        >
          <option value="">Select airport</option>
          {airportsList.map(airport => (
            <option key={airport.airport_id} value={airport.airport_id}>
              {airport.airport_iata_code} ({airport.airport_icao_code})
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Airport 2 *</label>
        <select
          value={formData.apair_airport2_id || ''}
          onChange={(e) => setFormData({ ...formData, apair_airport2_id: parseInt(e.target.value) })}
          required
        >
          <option value="">Select airport</option>
          {airportsList.map(airport => (
            <option key={airport.airport_id} value={airport.airport_id}>
              {airport.airport_iata_code} ({airport.airport_icao_code})
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Distance (meters) *</label>
        <input
          type="number"
          value={formData.apair_distance || ''}
          onChange={(e) => setFormData({ ...formData, apair_distance: e.target.value ? parseInt(e.target.value) : null })}
          min={0}
          required
        />
      </div>
    </>
  );
}

function AirportPairsList() {
  return (
    <CRUDList
      title="Airport Pairs"
      api={airportPairs}
      columns={['ID', 'Airport 1', 'Airport 2', 'Pair', 'Distance']}
      FormComponent={AirportPairForm}
      defaultFormData={{ apair_airport1_id: '', apair_airport2_id: '', apair_distance: '' }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.apair_id}</td>
          <td><span className="badge badge-info">{item.airport1_iata}</span></td>
          <td><span className="badge badge-info">{item.airport2_iata}</span></td>
          <td>{item.airport1_iata} ↔ {item.airport2_iata}</td>
          <td>{formatDistance(item.apair_distance)}</td>
        </>
      )}
    />
  );
}

export default AirportPairsList;
